import React, { PureComponent, ReactNode } from "react";
import { ChordHistoryInteractMode } from "../../../models/ChordHistoryOptions.model";
import { ICON_CHORD_MODE } from "../../../constants/iconConstants";
import { AppContextType } from "../../../AppContext";
import IconDropdown from "../../theme_reuse/IconDropdown";

interface Props {}
interface State {}

const INTERACT_MODES = [
  { mode: ChordHistoryInteractMode.SOUND, index: 0, title: "Mode: Click a chord to hear it", icon: ICON_CHORD_MODE.SOUND },
  { mode: ChordHistoryInteractMode.EDIT, index: 1, title: "Mode: Click a chord to Explore/Edit voicings", icon: ICON_CHORD_MODE.EDIT },
  {
    mode: ChordHistoryInteractMode.DELETE,
    index: 2,
    title: "Mode: Delete chords or entire scales from history",
    icon: ICON_CHORD_MODE.DELETE,
  },
  {
    mode: ChordHistoryInteractMode.CHOOSE,
    index: 3,
    title: "Mode: Click a chord to send it to the instrumentation tool",
    icon: ICON_CHORD_MODE.CHOOSE,
  },
];
const TITLES = INTERACT_MODES.map((i) => i.title);
const ICONS = INTERACT_MODES.map((i) => i.icon);

export default class ChordInteractModeDropdown extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  handleInteractModeSelect = (newIndex: number) => {
    const interactMode = INTERACT_MODES[newIndex].mode;
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: { interactMode } });
  };

  render(): ReactNode {
    const selectedIndex = INTERACT_MODES.find((i) => i.mode === this.context.chordHistoryOptions.interactMode)?.index || 0;
    return (
      <IconDropdown
        mini
        collapsedTitle="Chord Interaction Mode"
        titles={TITLES}
        icons={ICONS}
        selectedIndex={selectedIndex}
        onSelection={this.handleInteractModeSelect}
      />
    );
  }
}

ChordInteractModeDropdown.contextType = AppContextType;
